// Job openings and the JobPosting schema built from them.
//
// This lives in its own module rather than in the Careers page because the
// careers ROUTE needs the schema for its head tags. Importing a value out of
// the page module into the route creates an import cycle that breaks the
// server bundle at init ("createCsrfMiddleware is not a function"), so both
// the page and the route import from here instead.

export interface JobOpening {
  title: string;
  type: string;
  location: string;
}

export const openings: JobOpening[] = [
  { title: "Roofing Crew", type: "Full-Time", location: "Minnesota" },
  { title: "Siding Crew", type: "Full-Time", location: "Minnesota" },
  { title: "Sales / Project Manager", type: "Full-Time", location: "Minnesota" },
];

export const jobPostingSchema = openings.map((job) => ({
  "@context": "https://schema.org",
  "@type": "JobPosting",
  title: job.title,
  employmentType: job.type.includes("Full") ? "FULL_TIME" : "OTHER",
  jobLocation: {
    "@type": "Place",
    address: { "@type": "PostalAddress", addressLocality: "Minneapolis", addressRegion: "MN" },
  },
  hiringOrganization: {
    "@type": "Organization",
    name: "Kodiak Structures & Exteriors",
  },
  description: `${job.title} position at Kodiak Structures & Exteriors in the ${job.location} area.`,
}));
